/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-24 16:05:08
 * @LastEditors: K
 * @LastEditTime: 2022-09-21 13:43:14
 */
import { unwrapResult } from '@reduxjs/toolkit';
import { Table } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { RootDispatch } from '../../../../app/store';
import { getRegulatoryData } from '../../../monitoring/monitoringPageSlice';
import styles from '../../regulatoryDataTab.module.css'
import {
  selectTenantName,
  selectUserName,
} from "../../../../app/applicationSlice";
interface ZJProps {
  status: number
}

export const Zj = ({ status }: ZJProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [page, setPage] = useState<any>()  //表格 

  const [pageLoading, setPageLoading] = useState(false)  //表格 loading

  const [valueType, setValueType] = useState(true)   //双击控制密码

  const username = useSelector(selectUserName);


  const getPage = () => {
    setPageLoading(true)
    dispatch(getRegulatoryData({
      type: status
    }))
      .then(unwrapResult)
      .then((t: any) => {
        console.log(t, 'ttttt');
        setPage(t)
      })
      .finally(() => setPageLoading(false))
  }
  useEffect(() => {
    getPage()
    if(username == '黄文宙' || username == '程跃杨' || username == '张强' ){
      setValueType(false);
    }
  }, [])
  return (
    <div className={styles.content}>

      {page?.map((item: any) => {
        return (
          <div key={item.areaName}>
            {/* 标题 */}
            <div className={styles.title}>{item.areaName}( {<div className={styles.titleNum}> {item.number} </div>} )</div>
            {/* 表格区域 */}
            <div className={styles.tableWrap}>
              <Table
                className={styles.table}
                scroll={{ y: 200 }}
                dataSource={item.regulationList}
                pagination={false}
                loading={pageLoading}
                columns={[
                  {
                    title: '覆盖区域',
                    dataIndex: 'district',
                    key: 'district',
                    align: 'left',
                    width: '8rem'
                  },
                  {
                    title: '网址',
                    dataIndex: 'url',
                    key: 'url',
                    align: 'left',
                    render: function element(_, t) {
                      return <a onClick={() => window.open(t.url)}>{t.url}</a>
                    }
                  },
                  {
                    title: '登录账号',
                    dataIndex: 'username',
                    key: 'username',
                    align: 'left',
                    width: '10rem'
                  },
                  {
                    title: '登录密码',
                    dataIndex: 'password',
                    key: 'password',
                    align: 'left',
                    width: '10rem',
                    render: function element(_, t) {
                      return (
                        <div style={{ cursor: 'pointer' }}>
                          {
                            valueType ? <span style={{ fontSize: '12px' }}>●●●●●●</span> : <span>{t.password}</span>
                          }
                        </div>
                      )
                    }
                  },
                ]}
              />
            </div>
          </div>
        )
      })}

    </div>
  );
}

